import styled from 'styled-components';
import {
    PlayerStatsWrapper,
    PlayerInfoWrapper,
    PlayerDataWrapper,
    PlayerNameWrapper,
    PlayerPregameWrapper
} from '@mlb/react-patterns/v4/components/PlayerMatchup/playerMatchup.style';
import PlayerMatchup from './components/PlayerMatchupPattern';
import { GAME_CONTEXT_BREAKPOINTS } from '../themes/breakpoints';

const { DESKTOP, MD_MIN } = GAME_CONTEXT_BREAKPOINTS;

export const PlayerDuelWrapper = styled.div`
    font-family: var(--gameday-primary-font);

    ${PlayerMatchup} {
        @media (min-width: ${MD_MIN}) {
            padding-top: 16px;
        }
        @media (min-width: ${DESKTOP}) {
            padding-top: 24px;
        }
        &.right {
            ${PlayerDataWrapper} {
                padding-right: 0px;
            }
        }
        &.left {
            ${PlayerDataWrapper} {
                padding-left: 0px;
            }
        }
        > div:last-child > div:first-child > div {
            border-bottom: none;
            color: var(--gameday-game-context-primary-text-color);
        }
    }
    ${PlayerNameWrapper} {
        color: var(--gameday-game-context-primary-text-color);
        font-size: 12px;
        line-height: 12px;
        margin: 0;
        height: unset;
        max-width: 104px;
        overflow: hidden;
        text-overflow: ellipsis;
        @media (min-width: ${DESKTOP}) {
            font-size: 14px;
            line-height: 14px;
        }
    }
    ${PlayerStatsWrapper} {
        max-width: 125px;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: normal;
        text-align: center !important;
        @media (min-width: ${MD_MIN}) {
            max-width: 170px;
        }
        > span {
            color: var(--gameday-game-context-secondary-text-color);
            font-size: 12px;
            font-weight: 500;
            white-space: nowrap;
            line-height: 100%;
            width: 100%;
            @media (min-width: ${DESKTOP}) {
                font-size: 15px;
            }
        }
    }

    ${PlayerInfoWrapper} {
        height: 14px;
        margin: 4px 0 4px 0;
    }

    ${PlayerPregameWrapper} {
        font-size: 12px;
        line-height: 12px;
        color: var(--gameday-game-context-secondary-text-color);
        @media (min-width: ${DESKTOP}) {
            font-size: 14px;
            line-height: 14px;
        }
    }
`;

export const MatchupWrapper = styled.div`
    display: flex;
    justify-content: space-evenly;
    align-items: center;
`;
